import { render, staticRenderFns } from "./NewInterCut.vue?vue&type=template&id=b5ca3f9e&scoped=true"
import script from "./NewInterCut.vue?vue&type=script&lang=js"
export * from "./NewInterCut.vue?vue&type=script&lang=js"
import style0 from "./NewInterCut.vue?vue&type=style&index=0&id=b5ca3f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ca3f9e",
  null
  
)

export default component.exports